<template>
  <div class="app-container goods-attribute-view-form">
    <BjDivider right-fixed
      >{{ $t('SettingBaseDataCodeRule.edit.msg') }}
      <template slot="right">
        <el-button @click="tryCancel">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="handleConfirm('form')">{{ $t('saveText') }}</el-button>
      </template>
    </BjDivider>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('SettingBaseDataCodeRule.ruleCode')" prop="ruleCode">
            <BjInput
              v-model="form.ruleCode"
              :maxlength="MAX_LENGTH.DEFAULT"
              :disabled="isEdit"
              :placeholder="$t('inputText')"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SettingBaseDataCodeRule.ruleName')" prop="ruleName">
            <BjInput
              v-model="form.ruleName"
              :maxlength="MAX_LENGTH.DEFAULT"
              :disabled="isEdit"
              :placeholder="$t('inputText')"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('SettingBaseDataCodeRule.table.ruleDescription')" prop="description">
            <BjInput
              v-model="form.description"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <BjDivider>{{ $t('SettingBaseDataCodeRule.edit.code') }}</BjDivider>

    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :auto-fetch="false"
      search-btn-hide
      is-list
      res="codeRuleDetailDTOList"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" class="main-btn" @click="onAdd">{{ $t('addText') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <!-- <el-table-column type="index" label="序号" /> -->
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <template v-if="false" />
              <el-switch
                v-else-if="col.prop === 'status'"
                v-model="scope.row.status"
                @change="onStatus($event, scope.row)"
              />
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" class="edit-btn" @click="onEdit(scope.row)">{{ $t('editText') }}</el-button>
              <el-button
                :disabled="scope.row.status"
                type="text"
                class="delete-btn"
                @click="onDelete(scope.row)"
                >{{ $t('delText') }}</el-button
              >
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增/编辑弹窗 -->
    <DataForm ref="DataForm" :rule-dist-id="ruleDistId" @reFresh="reFresh" />
  </div>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import pageMiXin from '@/utils/page-mixin.js';
import { baseDataApi } from '@/api';
import DataForm from './DataFormRuleDist.vue';
const getDefaultForm = () => {
  return {
    ruleName: null,
    ruleCode: null,
    description: null,
  };
};

export default {
  name: 'SettingSchedulerRequestViewForm',
  components: {
    DataForm,
  },
  mixins: [viewMiXin, pageMiXin],
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      form: getDefaultForm(),
      // 表单校验
      rules: {
        ruleName: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        ruleCode: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        description: [{ required: false, message: this.$t('inputText'), trigger: 'blur' }],
      },
      queryApi: baseDataApi.detailCodeRuleDistId,
      // 查询参数
      queryParams: {
        ruleCode: null,
        ruleName: null,
      },

      labelList: [
        // { label: 'table.countText', prop: 'orderSeq', isCheck: true, disabled: false },
        { label: 'SettingBaseDataCodeRule.edit.type', prop: 'fieldTypeDescription', isCheck: true, disabled: false },
        { label: 'SettingBaseDataCodeRule.edit.value', prop: 'fieldValue', isCheck: true, disabled: false },
        { label: 'SettingBaseDataCodeRule.edit.data', prop: 'dateMask', isCheck: true, disabled: false },
        { label: 'SettingBaseDataCodeRule.edit.min', prop: 'seqLength', isCheck: true, disabled: false, width: 205 },
        { label: 'SettingBaseDataCodeRule.edit.start', prop: 'startValue', isCheck: true, disabled: false },
        // { label: '最大值', prop: 'tenantName', isCheck: true, disabled: false },
        // { label: '步长', prop: 'seqLength', isCheck: true, disabled: false },
        // { label: '修改人', prop: 'xx',isCheck: true, disabled: false, width: 135 },
        // { label: '修改日期', prop: 'xx', isCheck: true, disabled: false, width: 135 },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 129 },
      ],
    };
  },
  computed: {
    isSelected() {
      return !!this.selectedrow.length;
    },
    ruleDistId() {
      try {
        return this.form.codeRuleDistDTOList.content[0].ruleDistId;
      } catch (error) {
        return '';
      }
    },
  },
  watch: {
    info: {
      handler(info) {
        if (info) {
          this.form = this.$lodash.clone(info);
        }
      },
    },
    ruleDistId(v) {
      if (v) {
        this.queryParams.ruleDistId = v;
        this.$refs.BjPage && this.$refs.BjPage.fetchData();
      }
    },
  },

  mounted() {},
  methods: {
    reFreshParent() {
      this.$emit('reFresh');
    },
    handleConfirm(formName) {
      const API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) {
        API_DATA['_innerMap'] = {};
        delete API_DATA.codeRuleDistDTOList;
      }

      this.$refs[formName].validate(valid => {
        if (!valid) return this.$scrollToFormError();
        this.updateApi(API_DATA);
      });
    },

    onAdd() {
      this.$refs.DataForm.show();
    },
    onEdit(row) {
      this.$refs.DataForm.show(this.$lodash.clone(row));
    },
    onDelete(row, index) {
      this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.deleteApi([row]);
        })
        .catch(() => {});
    },

    /**
     *
     *
     */

    // deleteApi
    deleteApi(API_DATA) {
      baseDataApi.deleteCodeRuleDetail(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    // 编辑
    updateApi(API_DATA) {
      baseDataApi.addCodeRule(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.complete('SettingBaseDataCodeRuleIndex');
          }, 500);
        }
      });
    },
  },
};
</script>
<style lang="scss"></style>
